<template>
  <span class="text-caption text" v-on="$listeners" :style="[computedStyleVariables]">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'ClickableText',
  props: {
    color: {
      type: String,
      default: 'rgba(0, 0, 0, 0.59)',
    },
  },
  computed: {
    computedStyleVariables() {
      return {
        '--color': this.color,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  color: var(--color);
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
